export function formatType(type) {
    if (type === "affair")
        return "Devis";
    else if (type === "contract")
        return "Proposition de contrat";

    return type;
}
